import { cva, type VariantProps } from "class-variance-authority";
import type { ComponentProps } from "react";
import { cn } from "../lib/utils";

const spinnerVariants = cva(
  "inline-block animate-[ui4-spinner-loader_1s_ease-in_infinite] rounded-full bg-accent",
  {
    variants: {
      size: {
        sm: "size-4",
        md: "size-6",
        lg: "size-12",
      },
    },
    defaultVariants: {
      size: "md",
    },
  },
);

export type SpinnerProps = ComponentProps<"output"> &
  VariantProps<typeof spinnerVariants>;

export const Spinner = ({
  className,
  size,
  "aria-label": ariaLabel = "読み込み中",
  ...props
}: SpinnerProps) => {
  return (
    <output
      aria-label={ariaLabel}
      className={cn(spinnerVariants({ size }), className)}
      {...props}
    />
  );
};
